import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FinishProService } from '../../services/finish-pro.service';
import { LanguageService } from '../../services/language.service';
import { ConsentsData } from '../../pages/document-viewer/types/document-viewer-types';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingProService } from '../../services/loading-pro.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TermsAndConditionsComponent implements OnInit, AfterViewInit {

  _transParam: boolean = false;

  customConsents: ConsentsData[] = [];

  isRedirect: boolean = false;

  isAcceptAllConsents: boolean = false;

  disableAcceptButton: boolean = false;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _loadingPro: LoadingProService,
    private _finishPro: FinishProService,
    private _languageService: LanguageService) { }

  ngOnInit(): void {
    this.disableAcceptButton = false
    this._languageService.subscribeToTranslationChange(this as Component);
    this.addConsents();
  }

  ngAfterViewInit(): void {
    this._loadingPro.setLoader(false);
    this._loadingPro.setNextOperationLoader(false);
  }

  addConsents(): void {
    this.customConsents = [];
    if (this._finishPro.operationDetailResponse?.CheckBoxConsent?.length > 0) {
      this.isAcceptAllConsents = this.isRedirect ?? true;
      this._finishPro.operationDetailResponse.CheckBoxConsent.forEach(c => {
        this.customConsents.push({ id: c.Key, text: c.Value, checked: this.isRedirect ? true : false });
      });
    } else {
      this.isAcceptAllConsents = true;
    }
  }

  onChangeConsents(checked: boolean, id: number): void {
    const index = this.customConsents.findIndex(element => element.id === id);
    this.customConsents[index].checked = checked;

    let allAccepted = true;
    this.customConsents.forEach(c => {
      if (!c.checked) {
        allAccepted = false;
      }
    });
    this._finishPro.customCheckbox.emit(allAccepted);
    this.isAcceptAllConsents = allAccepted;
  }

  onNavigate(): void {
    this.disableAcceptButton = true;
    this._finishPro.operationRequest.acceptedCustomCheckbox = true;
    const route = this._finishPro.getRoutePath();
    this._router.navigate([route], { relativeTo: this._route.parent });
  }
}
